import React from 'react'
import * as UI from 'ui'
import WhenOrderIsDeliveryNote from 'pages/app/inventory/order/partials/WhenOrderIsDeliveryNote'
import InventoryOrderDaysHighlightCard from 'widgets/inventory/InventoryOrderDaysHighlightCard'
import InventoryOrderExpectedGuestsHighlightCard from 'widgets/inventory/InventoryOrderExpectedGuestsHighlightCard'
import { Link, WhenRouteHasParameter } from '@morningtrain/react-navigation'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { WhenModel } from '@morningtrain/react-resources'
import InventoryOrderTransactionsHighlightCard from 'widgets/inventory/InventoryOrderTransactionsHighlightCard'
import InventoryOrderStatus from 'pages/app/inventory/order/partials/InventoryOrderStatus'
import WhenOrderIsPending from 'pages/app/inventory/order/partials/WhenOrderIsPending'
import WhenOrderIsDraft from 'pages/app/inventory/order/partials/WhenOrderIsDraft'
import InventoryOrderUnhandledHighlightCard from 'widgets/inventory/InventoryOrderUnhandledHighlightCard'
import InventoryOrderHandledHighlightCard from 'widgets/inventory/InventoryOrderHandledHighlightCard'
import * as Icons from 'ui/icons'
import { Translation, useTranslation } from '@morningtrain/react-translations'
import { useEnvValue } from '@morningtrain/react-helpers'
import { TabsField } from 'support/fields'

export default function OrderPageHeader () {

  const [excludeWithoutNorm, setExcludeWithoutNorm] = useEnvValue('globals.inventory.exclude_without_norms', true)

  const excludeWithoutNormTrans = useTranslation('exclude_without_norm')
  const showAllTrans = useTranslation('show_all')

  const pageTitle = (
    <UI.WithSubtitle subtitle={<InventoryOrderStatus type='delivery_note'/>}>
      <WhenModel exists={false}>
        <WhenRouteHasParameter name='inventory_order' negate>
          <TranslatedTitle name='titles.create'/>
        </WhenRouteHasParameter>
      </WhenModel>
      <WhenModel>
        <WhenOrderIsDeliveryNote>
          <TranslatedTitle name='titles.delivery_note'/>
        </WhenOrderIsDeliveryNote>
        <WhenOrderIsPending>
          <TranslatedTitle name='titles.pending_order'/>
        </WhenOrderIsPending>
        <WhenOrderIsDraft>
          <TranslatedTitle name='titles.draft_order'/>
        </WhenOrderIsDraft>
      </WhenModel>
    </UI.WithSubtitle>
  )

  const innerItems = (
    <>
      <InventoryOrderDaysHighlightCard/>
      <InventoryOrderExpectedGuestsHighlightCard/>
      <InventoryOrderHandledHighlightCard/>
      <InventoryOrderUnhandledHighlightCard/>
      <WhenOrderIsDraft negate>
        <InventoryOrderTransactionsHighlightCard/>
      </WhenOrderIsDraft>
    </>
  )

  return (
    <>
      <UI.SpaceBetween>
        <Link route='app.inventory.order.delivery' className='block mb-2'>
          <UI.Button>
            <Icons.ArrowLeft className='mr-2'/>
            <span className='block mt-1'><Translation name='generic.back_to_delivery'/></span>
          </UI.Button>
        </Link>
        <TabsField
          options={[{ value: 'exclude_without_norm', label: excludeWithoutNormTrans }, {
            value: 'show_all',
            label: showAllTrans
          }]}
          defaultValue={'exclude_without_norm'}
          onChange={(value) => setExcludeWithoutNorm(value === 'exclude_without_norm')}
        />
      </UI.SpaceBetween>
      <UI.PageHeader title={pageTitle}>
        <div className='space-y-3 xl:space-y-0 xl:space-x-5 flex w-full xl:w-4/5 xl:justify-end flex-col xl:flex-row'>
          {innerItems}
        </div>
      </UI.PageHeader>
    </>
  )
}
